import axios from "axios";


export default axios.create({
    baseURL: "https://wodl64bt21.execute-api.eu-west-3.amazonaws.com/dev/"
    //baseURL: "http://localhost:5000"
})